import React, { useState, useEffect, useRef } from 'react';
import { Wrench, TrendingUp, Building2, Users, ShieldCheck, BarChart3, UserCheck, Home, Settings, IndianRupee, FileCheck, Droplet, Zap, Mail } from 'lucide-react';
import './Services.css';
import mantanance from "../../Assets/Image/mantanance.jpg"
import BudgetPlanning from "../../Assets/Image/Budget palnning.jpg"
import assetmanagement from "../../Assets/Image/asset management.jpg"
import societymanagement from "../../Assets/Image/society management.jpg"
import paterolling from "../../Assets/Image/paterolling.png"
import communitypoiing from "../../Assets/Image/community polling.jpg"
import visitormanagement from "../../Assets/Image/visitor management.jpg"
import homeautomation from "../../Assets/Image/Home Automation.jpg"
import societyautomation from "../../Assets/Image/Society Automation.jpg"
import camcollection from "../../Assets/Image/cam coll.jpg"
import auditing from "../../Assets/Image/audit.jpg"
import watermeter from "../../Assets/Image/water meter collectin.jpg"
import ElectricBill from "../../Assets/Image/water meter collectin.jpg"
import envite from "../../Assets/Image/E-Invite.jpg"


const Services = ({serviceRef, activeIntegration, onActiveChange}) => {
  // activeIntegration is now controlled by parent (LandingPage)
  // so AnikaAi can sync voice with the displayed feature
  const sectionObserverRef = useRef(null);
  const setActiveIntegration = (idx) => onActiveChange && onActiveChange(idx);

  const integrations = [
    {
      id: 1,
      icon: Wrench,
      name: "Maintenance",
      description: "Streamline maintenance requests and track repairs efficiently with automated scheduling and real-time updates.",
      circle: "inner",
      color: "#10b981",
      image: mantanance
    },
    {
      id: 2,
      icon: TrendingUp,
      name: "Budget Planning",
      description: "Plan and manage your society budget with intelligent forecasting and expense tracking tools.",
      circle: "inner",
      color: "#3b82f6",
      image: BudgetPlanning
    },
    {
      id: 3,
      icon: Building2,
      name: "Asset Management",
      description: "Keep track of all society assets, their condition, and maintenance schedules in one centralized system.",
      circle: "inner",
      color: "#8b5cf6",
      image:assetmanagement
    },
    {
      id: 4,
      icon: Users,
      name: "Society Management",
      description: "Complete society administration solution with member management, communication, and governance tools.",
      circle: "inner",
      color: "#ec4899",
      image: societymanagement
    },
    {
      id: 5,
      icon: ShieldCheck,
      name: "Patrolling",
      description: "Monitor security patrols with GPS tracking, incident reporting, and scheduled checkpoints.",
      circle: "inner",
      color: "#f59e0b",
      image: paterolling
    },
    {
      id: 6,
      icon: BarChart3,
      name: "Community Polling",
      description: "Engage residents with polls and surveys to make democratic decisions and gather feedback.",
      circle: "inner",
      color: "#06b6d4",
      image: communitypoiing
    },
    {
      id: 7,
      icon: UserCheck,
      name: "Visitor Management",
      description: "Manage and track visitor entries with digital registration, pre-approval, and security notifications.",
      circle: "outer",
      color: "#14b8a6",
      image: visitormanagement
    },
    {
      id: 8,
      icon: Home,
      name: "Home Automation",
      description: "Control smart home devices and automate your living space for comfort and energy efficiency.",
      circle: "outer",
      color: "#f97316",
      image: homeautomation
    },
    {
      id: 9,
      icon: Settings,
      name: "Society Automation",
      description: "Automate common area systems including lighting, water pumps, and access control systems.",
      circle: "outer",
      color: "#6366f1",
      image: societyautomation
    },
    {
      id: 10,
      icon: IndianRupee,
      name: "CAM Collection",
      description: "Simplified Common Area Maintenance fee collection with automated reminders and payment tracking.",
      circle: "outer",
      color: "#22c55e",
      image: camcollection
    },
    {
      id: 11,
      icon: FileCheck,
      name: "Auditing",
      description: "Comprehensive financial auditing tools for transparent society fund management and reporting.",
      circle: "outer",
      color: "#a855f7",
      image: auditing
    },
    {
      id: 12,
      icon: Droplet,
      name: "Water Meter Collection",
      description: "Track water consumption with smart metering and automated billing for accurate usage-based charges.",
      circle: "outer",
      color: "#0ea5e9",
      image: watermeter
    },
    {
      id: 13,
      icon: Zap,
      name: "Electric Bill Collection",
      description: "Streamline electricity bill collection with digital invoicing and payment reminders.",
      circle: "outer",
      color: "#eab308",
      image: ElectricBill
    },
    {
      id: 14,
      icon: Mail,
      name: "E-Invite",
      description: "Create and send digital invitations for society events with RSVP tracking and guest management.",
      circle: "outer",
      color: "#ef4444",
      image: envite
    }
  ];

  // Voice is now handled centrally by AnikaAi in LandingPage

  // Auto-rotation: notify parent to advance to next feature
  // Parent owns the state, so we pass integrations.length up so parent can mod
  useEffect(() => {
    const interval = setInterval(() => {
      // Use callback form - parent useState supports this
      onActiveChange && onActiveChange(prev => (prev + 1) % integrations.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [integrations.length, onActiveChange]);

  const getSpiralPosition = (index, total) => {
    const t = index / total;
    const rotationOffset = (activeIntegration / total) * 2 * Math.PI;
    const turns = 2;
    const minRadius = 70;
    const maxRadius = 320;
    const angle = t * Math.PI * 2 * turns + rotationOffset;
    const radius = minRadius + (maxRadius - minRadius) * t;
    const x = Math.cos(angle) * radius;
    const y = Math.sin(angle) * radius;
    return { x, y, radius };
  };

  const generateSpiralPath = () => {
    const points = [];
    const steps = 200;
    const turns = 2;
    const minRadius = 70;
    const maxRadius = 320;
    const rotationOffset = (activeIntegration / integrations.length) * 2 * Math.PI;
    
    for (let i = 0; i < steps; i++) {
      const t = i / steps;
      const angle = t * Math.PI * 2 * turns + rotationOffset;
      const radius = minRadius + (maxRadius - minRadius) * t;
      const x = 300 + Math.cos(angle) * radius;
      const y = 300 + Math.sin(angle) * radius;
      points.push(`${x},${y}`);
    }
    return `M ${points.join(' L ')}`;
  };

  const currentIntegration = integrations[activeIntegration];

  return (
    <div className="society-feature mt-5" ref={serviceRef}>
      <div className="integration-container">
        <div className="left-section">
          <div className="integration-hub">
            {/* Center Orb */}
            <div className="center-orb">
              <div className="dashed-circle"></div>
            </div>

            {/* Spiral Path Line */}
            <svg className="connection-lines" viewBox="0 0 600 600">
              <defs>
                <linearGradient id="spiralGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#6A66FB" stopOpacity="0.8" />
                  <stop offset="50%" stopColor="#8B5CF6" stopOpacity="0.6" />
                  <stop offset="100%" stopColor="#6A66FB" stopOpacity="0.3" />
                </linearGradient>
              </defs>
              
              {/* Main Spiral Path */}
              <path
                d={generateSpiralPath()}
                fill="none"
                stroke="url(#spiralGradient)"
                strokeWidth="2.5"
                strokeDasharray="6,6"
                className="spiral-path"
              />
            </svg>

            {/* Icons positioned on spiral */}
            {integrations.map((integration, index) => {
              const { x, y } = getSpiralPosition(index, integrations.length);
              const isActive = index === activeIntegration;

              return (
                <div
                  key={integration.id}
                  className={`rotating-icon ${isActive ? 'active-icon' : ''}`}
                  style={{
                    transform: `translate(${x}px, ${y}px)`,
                    marginTop:"-35px",
                    marginLeft:"-35px"
                  }}
                  onClick={() => setActiveIntegration(index)}
                >
                  <div
                    className="icon-circle"
                    style={{
                      borderColor: integration.color,
                      boxShadow: isActive ? `0 0 40px ${integration.color}80, 0 0 60px ${integration.color}40` : 'none'
                    }}
                  >
                    <div className="icon-inner">
                      <integration.icon size={isActive ? 28 : 28} strokeWidth={1.5} color={integration.color} />
                    </div>
                  </div>
                </div>
              );
            })}

            {/* Ambient Glow */}
            <div className="ambient-glow glow-1"></div>
            <div className="ambient-glow glow-2"></div>
          </div>
        </div>

        <div className="right-section">
          <button className="integrations-badge fs-6">Services Feature</button>

          <h1 className="main-heading-services" key={activeIntegration}>
            {currentIntegration.name.split("").map((char, index) => (
              <span
                key={index}
                className="wave-chardddd"
                style={{
                  animationDelay: `${index * 0.03}s`,
                }}
              >
                {char === " " ? "\u00A0" : char}
              </span>
            ))}
          </h1>

          <p className="sub-text">
            {currentIntegration.description}
          </p>

          <div className="features">
            <div className="feature-item">
              <svg className="check-icon" viewBox="0 0 24 24" fill="none">
                <path
                  d="M5 13l4 4L19 7"
                  stroke="#6366F1"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>Automated workflow management</span>
            </div>

            <div className="feature-item">
              <svg className="check-icon" viewBox="0 0 24 24" fill="none">
                <path
                  d="M5 13l4 4L19 7"
                  stroke="#6366F1"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>Real-time data synchronization</span>
            </div>
          </div>
      
          {/* <img src={currentIntegration.image} alt="" style={{height:"250px",width:"45%",marginBottom:'10px'}}/> */}
    
          <button className="cta-button">
            <span>Explore More</span>
            <svg className="download-icon" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 4v12m0 0l-4-4m4 4l4-4M4 20h16"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Services;